var PES = PES || {};
PES.VideoPlayer = function () {
    var init = function () {
        $(document).on("click", ".video-container", function () {
            $(this).css("height", "362px");
            $(this).find(".video-container__cover").remove();
            $(this).find(".video-container__playbutton").remove();

            var iframe = $(this).find("iframe");
            iframe.show();
            iframe.attr("src", $(iframe).attr("src") + "?autoplay=1");
            iframe.attr("allow", "autoplay");
        });
    };

    return {
        init: init
    };
}();